import React, { useState } from 'react';
import { Paper, makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import UserTableRow from './UserTableRow';
import AddIcon from '@material-ui/icons/Add';
import UserCrudDrawer from './CRUD/UserCrudDrawer';
import { applicationIds, roles } from '../../Config/constants';

export default function UserTable(props) {

    const classes = useStyles();

    const { t } = useTranslation();
    const [crudDrawerOpen, setCrudDrawerOpen] = useState(false);
    const [createModus, setCreateModus] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null);

    const userRows = props.users.map(u => {
        var id = u.id;
        var loginName = u.loginName;
        var firstName = u.firstName;
        var lastName = u.lastName;
        var email = u.email;
        var rollen = u.roles.filter(x => x.applicationId === applicationIds.SMARTPRODUCTION).map(x => {
            if (x.roleId === roles.ADMINISTRATOR) {
                x.color = 'rgba(237,26,26,0.7)';
            }
            else if (x.roleId === roles.OPERATOR || x.roleId === roles.SCHRIJNWERKERIJOPERATOR || x.roleId === roles.EXTRUSIEOPERATOR) {
                x.color = 'rgba(26,40,237,0.6)';
            }
            else if (x.roleId === roles.PLOEGCHEF) {
                x.color = 'rgba(27,158,62,0.6)';
            }
            return x;
        })
        if (rollen === "") {
            rollen = "/";
        }
        return (
            { id, loginName, firstName, lastName, email, rollen });
    });

    const openUserCrudDrawer = (create, userId) => {
        if (create) {
            setCreateModus(true);
            setUserToEdit(null);
        }
        else {
            setUserToEdit(props.users.find(x => x.id === userId));
            setCreateModus(false);
        }
        setCrudDrawerOpen(true);
    }

    const closeUserCrudDrawer = () => {
        setCrudDrawerOpen(false);
    }

    const editUser = (userId) => {
        openUserCrudDrawer(false, userId);
    }

    return <div className={classes.tableContainer}>
        {/* <div className={classes.title}>{props.active ? "Active Workflows" : "Workflow history"}</div> */}
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow className={classes.headRow}>
                        <TableCell className={classes.headCell} style={{ width: "5%" }}>{t('Id')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "15%" }}>{t('Gebruikersnaam')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "15%" }}>{t('Voornaam')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "20%" }}>{t('Familienaam')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "20%" }}>{t('Emailadres')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "20%" }}>{t('Rollen')}</TableCell>
                        <TableCell className={classes.headCell} style={{ width: "5%" }}><button className={classes.addButton} onClick={() => openUserCrudDrawer(true)}><AddIcon></AddIcon></button></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {userRows.map((row) => (
                        <UserTableRow key={row.id} row={row} {...props} editUser={editUser}></UserTableRow>
                    ))}
                </TableBody>
                <UserCrudDrawer roles={props.roles} create={createModus} drawerOpen={crudDrawerOpen} closeDrawer={closeUserCrudDrawer} refresh={props.refresh} userToEdit={userToEdit}></UserCrudDrawer>
            </Table>
        </TableContainer>

    </div>
}

const useStyles = makeStyles({

    paper: {
        boxShadow: 'none',
        backgroundColor: "rgb(1,1,1,0)"
    },
    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        float: "left",
        marginBottom: "10px",
        paddingLeft: "20px",
        marginTop: "15px"
    },
    tableContainer: {
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#000000",
        padding: "0px",
        paddingTop: "0px",
        paddingLeft: "15px",
        border: "none",
    },
    table: {
        borderSpacing: '0px 5px',
        borderCollapse: 'separate',
    },
    addButton: {
        outline: "none",
        border: "none",
        cursor: "pointer"
    }

});